
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './polyfills';
import './i18n';
import App from './App';
import config from './config';
import './index.css';

/* eslint-disable react/jsx-filename-extension */
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router basename={config.app.basename}>
    <App />
  </Router>
);
